import api from '../../axios/api';
import { ISite } from '../../models/isite';
import { fetchEquipmentsService } from '../../services/equipments';
import { i18n } from '../../translate/i18n';
import filterObjectToQuery from '../../utils/filterObjectToQuery';
import siteObjectToQuery from '../../utils/siteObjectToQuery';
import { IServiceDraft } from '../reducers/createService';
import { ISelectedFilter, TSetFilters } from '../reducers/serviceDrafts';
import * as actionTypes from './actionTypes';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';

const CancelToken = axios.CancelToken;
let fetchServicesDrafts_cancel: any;

type TFetchServiceDrafts = {
  page: number;
  limit: number;
  orderBy: string;
  order: string;
  filteredEquipment?: {label: string, value: string} | null;
  filteredEquipmentServices?: {label: string, value: string}[];
  filteredServiceTypes?: {label: string, value: string}[];
  filteredFrequencies?: {label: string, value: string}[];
  filteredPlaces?: {label: string, value: string}[];
  filteredModels?: {label: string, value: string}[];
  filteredSites?: ISite[];
  filterCreatedAtStart?: Date | null,
  filterCreatedAtEnd?: Date | null,
  filterModifiedAtStart?: Date | null,
  filterModifiedAtEnd?: Date | null,
}

const fetchServiceDraftsStart = () => {
  return {
    type: actionTypes.SERVICE_DRAFTS_FETCH_START,
  }
}

const fetchServiceDraftsSuccess = (drafts: {rows: IServiceDraft[], count: number}) => {
  return {
    type: actionTypes.SERVICE_DRAFTS_FETCH_SUCCESS,
    payload: drafts,
  }
}

const fetchServiceDraftsFail = () => {
  return {
    type: actionTypes.SERVICE_DRAFTS_FETCH_FAIL,
  }
}

export const serviceDraftsFetch = ({page, limit, orderBy, order, filteredEquipment = null, filteredServiceTypes = [], filteredFrequencies = [], filteredPlaces = [], filteredModels = [], filteredSites = [], filterCreatedAtStart = null, filterCreatedAtEnd = null, filterModifiedAtStart = null, filterModifiedAtEnd = null}: TFetchServiceDrafts) => {
  fetchServicesDrafts_cancel && fetchServicesDrafts_cancel();
  let query = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
  query += filteredSites.length > 0 ? `&site=${siteObjectToQuery(filteredSites)}` : '';
  query += filteredPlaces.length > 0 ? `&place=${filterObjectToQuery(filteredPlaces)}` : '';
  query += filteredModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredModels)}` : '';
  query += filteredEquipment ? `&equipment=${filteredEquipment.value}` : '';
  query += filteredServiceTypes.length > 0 ? `&serviceType=${filterObjectToQuery(filteredServiceTypes)}` : '';
  query += filteredFrequencies.length > 0 ? `&frequency=${filterObjectToQuery(filteredFrequencies)}` : '';
  query += filterCreatedAtStart ? `&createdAtStart=${filterCreatedAtStart.toISOString()}` : '';
  query += filterCreatedAtEnd ? `&createdAtEnd=${filterCreatedAtEnd.toISOString()}` : '';
  query += filterModifiedAtStart ? `&modifiedAtStart=${filterModifiedAtStart.toISOString()}` : '';
  query += filterModifiedAtEnd ? `&modifiedAtEnd=${filterModifiedAtEnd.toISOString()}` : '';

  return (dispatch: any) => {
    dispatch(fetchServiceDraftsStart());
    api.get('/servicedrafts' + query, {
      cancelToken: new CancelToken(function executor(c) {
        fetchServicesDrafts_cancel = c;
      })
    })
      .then((res)=> {
        dispatch(fetchServiceDraftsSuccess(res.data.data));
      })
      .catch(err => {
        dispatch(fetchServiceDraftsFail());
      });
  }
}

const fetchEquipmentsStart = () => {
  return {
    type: actionTypes.SERVICE_DRAFTS_FETCH_EQUIPMENTS_START
  };
};

const fetchEquipmentsSuccess = (equipments: any) => {
  return {
    type: actionTypes.SERVICE_DRAFTS_FETCH_EQUIPMENTS_SUCCESS,
    payload: equipments,
  };
};

const fetchEquipmentsFail = () => {
  return {
    type: actionTypes.SERVICE_DRAFTS_FETCH_EQUIPMENTS_FAIL,
  };
};


export const serviceDraftsFiltersFetchEquipments = (page: number, limit: number, search: string, order: string, orderBy: string, sites: ISite[] , filteredPlaces: ISelectedFilter[], filteredModels: ISelectedFilter[]) => {
  return (dispatch: any) => {
    dispatch(fetchEquipmentsStart());
    fetchEquipmentsService(page, limit, search, order, orderBy, sites, filteredPlaces, filteredModels, [], [], [], false, false)
      .then((res: any) => {
        dispatch(fetchEquipmentsSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchEquipmentsFail());
      });
  };
};

export const serviceDraftsSetFilters = (filters: TSetFilters) => {
  return {
    type: actionTypes.SERVICE_DRAFTS_SET_FILTERS,
    payload: filters,
  }
}

export const serviceDraftsClearFilters = () => {
  return {
    type: actionTypes.SERVICE_DRAFTS_CLEAR_FILTERS,
  }
}

const deleteDraftStart = (draftId: string) => {
  return {
    type: actionTypes.SERVICE_DRAFTS_DELETE_DRAFT_START,
    payload: draftId
  }
}

const deleteDraftSuccess = () => {
  return {
    type: actionTypes.SERVICE_DRAFTS_DELETE_DRAFT_SUCCESS,
  }
}

const deleteDraftFail = () => {
  return {
    type: actionTypes.SERVICE_DRAFTS_DELETE_DRAFT_FAIL,
  }
}

export const serviceDraftsDeleteDraft = (draftId: string, fetchQuery: TFetchServiceDrafts) => {
  return (dispatch: any) => {
    dispatch(deleteDraftStart(draftId));
    api.put(`/servicedrafts/${draftId}/delete`)
      .then((res)=> {
        dispatch(deleteDraftSuccess());
        toastr.success(i18n.t('createService.toastrSucessDeleteDraftTitle'), '')
        dispatch(serviceDraftsFetch(fetchQuery));
      })
      .catch(err => {
        dispatch(deleteDraftFail());
        toastr.error('createService.toastrErrorDeleteDraftTitle', err.message);
      });
  }
}